import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { downloadFile } from "../../../../common/download";
import Modal from "../../../../components/Modal";
import LenderUgroService from "../../../../services/lender";

const RepaymentModal = ({
  toggleModal,
  userType,
  leadId,
  lenderId,
  state,
  reloadTable,
}) => {
  const inputRef = useRef(null);
  const location = useLocation();
  let heading = 'repayment'

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();
  const formSubmitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;
      let formData = new FormData();
      formData.append("file", file);
      if (heading === "repayment") {
        formData.append("lead_id", leadId)
        formData.append("lender_id", lenderId)
      }
      
      response = await LenderUgroService.repaymentUpload(
        userType,
        formData,
        heading
      );

      if (response?.data?.status?.code === 1) {
        toast.success(
          response?.data?.messages?.success?.others[0]
        );
        toggleModal();
        reloadTable();
      }
    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]);
      setErrors(error);
    }
    setLoading(false);
  };

  const DownloadSamplefile = async () => {
    try {
      let response;
      response = await LenderUgroService.getsamplefile({
        responseType: 'blob',
        heading,
        lenderId
      });
      downloadFile(response?.data, `${heading}_sample_template.xlsx`);
      if (response?.data?.status?.code === 1) {
        toast.success(
          response?.data?.messages?.success?.others[0]
        );
      }

    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      // toast.error(error?.form?.[0] || error?.others?.[0]);
      toast.error("Failed to download")
      setErrors(error);
    }
  }

  return (
    <Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true}>
    <div className="modal-header-container">
      <div className="modal-title"> {`Add ${heading.charAt(0).toUpperCase() + heading.substring(1)} Info `}</div>
      <div className="closeModalView" onClick={toggleModal}>
        <span className="closeModalIcon">x</span>
      </div>
    </div>
      <div className="text-right px-4 pt-2">
        <a style={{ color: "#007bff", cursor: "pointer" }} onClick={DownloadSamplefile}>
          Sample file
        </a>
      </div>
    <div className="p-4 modalData">

      <form onSubmit={formSubmitHandler}>
        <div class="form-group">
          <label>Upload File</label>
          <div class="row">
            <div class="col-12">
              <input
                ref={inputRef}
                file={file}
                onChange={(e) => setFile(e.target.files[0])}
                type="file"
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <button type="submit" class="btn btn-custom btn-custom-height p-0" disabled={!file || loading}>
            {loading ? <div className="loader" /> : "Submit"}
          </button>
          <button
            type="button"
            class="btn btn-outline-custom ml-2"
            data-dismiss="modal"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </Modal>
  );
};

export default RepaymentModal;
